import React, { Component } from 'react';
import General from '../../../Utils/General';
import ChatInput from '../ChatInput';
import MessageFeather from '../MessageFeather';
import WelcomeScreen from '../WelcomeScreen/index';
import { FileUploadAPIType } from '../Response/Model';
import { FileSizeUnitMapping } from '../Response/Constants';
import WarningIcon from '../../../../assets/imgs/icons/warning.svg';
import { LanguageContext } from '../../../../src/Utils/Contexts';
import { ToasterIdentifier } from '../../../Utils/constants';
import Snackbar from '../Snackbar/Snackbar';
import { Toaster } from '../Toaster';
import { NetworkStatus, ToasterMessage } from '../Toaster/ToasterBody';
import ChatOverlay from '../ChatOverlay';
import { truthyOrFalsy } from '../../../Utils/Contexts';
import { TString } from '../Response/Utils';
import GetInTouch from '../GetInTouch';
import styled from 'styled-components';
import Feedback from '../OverallFeedback/Feedback';
import Modal from '../../FlyfishComponents/Modal';
import MonacoCartItem from '../../FeatureComponents/Flyfish/MonacoTheme/MonacoCartItem';
import Axios from 'axios';
const SCROLL_CONST = {
	scroll_debounce_time: 1200,
	scroll_top: 5,
};
var resizeTimeout;

interface Props {
	colorScale: any;
	boxRef: any;
	getProductDetails;
	isChatBodyVisible: boolean;
	chatMessages: any;
	chatInput: string;
	handleInput: Function;
	handleKeyUp: Function;
	formChatInputHidden: boolean;
	handleSubmit: Function;
	quickLinks: any;
	isSpeech: boolean;
	createCart: Function;
	data: any;
	handleFocus: Function;
	predSearchToggle: boolean;
	predSearchResponse: any;
	togglePredSearch: any;
	assignPredSearchQues: Function;
	showWelcomeScreen: boolean;
	theme: any;
	isChatInputDisabled: boolean;
	isCampaignWorkflowTriggered: boolean;
	stopSpeaking: Function;
	toggleSpeakingFunctionality: Function;
	suggestions: any;
	welcomeMessage: string;
	toggleLoginScreen: Function;
	setLangListVisibility: (visibility: boolean) => void;
	headerExternalTheme?: boolean;
	showFooter?: Function;
	handleModalToggle: Function;
	snackBarMessage: string;
	toasterBodyIdentifier: any;
	isConnectedToNetwork: boolean;
	toasterMessageTemplate: any;
	toggleOverlay: Function;
	isOverlayVisible: boolean;
	notifications: any;
	closeNotification: Function;
	polls: any;
	pollSubmit: Function;
	surveys: any;
	surveySubmit: Function;
	isChatInputHidden: boolean;
	popUpSnackBar: Function;
	getLoader: Function;
	voiceResponse: boolean;
	langCode: string;
	flyFishChangesReq: boolean;
	isdisableInput: boolean;
	channel?: string;
	addUserResponse: Function;
	addServerMessage: Function;
	toggleLang?: Function;
	getCartId: Function;
	makePayment: Function;
	handlePaymentStatus: Function;
	paymentStatus;
	HideWelcomeScreen: Function;
	handleSelectedProduct?: any;
	changeScreen: Function;
	currentScreen: string;
	logoImagePath: Function;
	workflowData?: any;
	tenantId?: any;
	botId?: any;
	conversationId?: any;
	token?: any;
	mandatoryCollection: boolean;
	detailCollection: boolean;
	disableMandatory: Function;
	handleDisableGetInTouch: Function;
	disableGetInTouch: boolean;
	enableGetInTouch: boolean;
	submitFeedback: Function;
	botClosingModal: boolean;
	showFeedbackPopup: boolean;
	openThumbsPopup: Function;
	thumbFilledUp: boolean;
	productCarousel: boolean;
	showForm: boolean;
	lang: string;
	reason: any;
	getProductDescription: Function;
	EbotId: string;
	selectedColor: string;
	selectedTheme: string;
	recommendationHeading: string;
	showOnHover: string;
	selectedButton: any;
	cartId;
	cartExist;
	conversationalId;
	userQuery;
	enableStyleAdvisor;
	advisorTitle;
	staticDetailsURL;
	enableVoiceModal;
	voiceText;
}

interface State {
	isWelcomeScreenVisible: boolean;
	isError: boolean;
	val: FileUploadAPIType;
	chatBodyClick: boolean;
	chatInput: any;
	showToaster: boolean;
	showChatScreen: boolean;
	showMonacoCart: boolean;
	totalItem;
	totalPrice;
}
export const TOASTER = styled.div`
	&.ff-toaster {
		position: fixed;
		bottom: 164px;
		z-index: 9999999;
		width: 330px;
		padding: 12px 16px;
		border-radius: 19.5px;
		box-shadow: 0 12px 24px 0 rgba(0, 0, 0, 0.28);
		background-color: ${(props) => {
		return 'var(--colorScale-9)';
	}};
		border: 1px solid
			${(props) => {
		return props.colorMode === 'dark'
			? 'var(--colorScale-6)'
			: 'var(--colorScale-4)';
	}};

		color: ${(props) => {
		return 'var(--colorScale-0)';
	}};

		display: flex;

		justify-content: center;

		overflow-wrap: anywhere;
		&.ff-ecom {
			bottom: 20px;
		}
	}
`;

export const MonacoCart = styled.div`
	padding: 20px;
	height: 100vh;
	& > .bag-titile-and-close-button {
		display: flex;
		align-items: center;
		justify-content: space-between;
		font-family: var(--fontFamily);
		& > svg {
			width: 15px;
			cursor: pointer;
		}
	}
	& > .ff-cart-products-container {
		overflow: auto;
		height: 79vh;
		overflow: auto;
		max-height: 700px;
		margin-bottom: 14px;
	}
	& > .ff-cart-checkout-button {
		width: 100%;
		border-radius: 0px;
		height: 45px !important;
		font-weight: normal;
		text-transform: uppercase;
		border: 1px solid var(--selectedColor);
		color: var(--selectedColor);
		display: flex;
		justify-content: center;
		align-items: center;
		font-family: var(--fontFamily);
		padding: 0px 18%;
		font-size: 14px;
		letter-spacing: 0.5px;
		cursor: pointer;
		&:hover {
			background-color: var(--selectedColor);
			color: #fff;
			transition: 0.5s ease all;
		}
		> div {
			display: flex;
			align-items: center;
			width: 70%;
			> div {
				&:nth-of-type(2) {
					font-size: 25px;
					font-weight: bold;
					width: 100%;
					height: 100%;
					display: flex;
					justify-content: center;
					align-items: center;
					text-align: center;
					margin-top: -10px;
				}
			}
		}
	}
`;

class ChatBody extends Component<Props, State> {
	constructor(props) {
		super(props);
		this.state = {
			isWelcomeScreenVisible: true,
			showToaster: false,
			isError: false,
			totalItem: 0,
			totalPrice: '',
			val: {
				fileSizeUnit: 0,
				fileSizeAmount: 0,
				typeId: 0,
				fileSubType: [''],
				fileUploadAPI: '',
			},
			chatBodyClick: false,
			chatInput: '',
			showChatScreen: false,
			showMonacoCart: false,
		};
	}

	setBotBodyHeight() {
		const r = getComputedStyle(document.querySelector(':root'));
		var mobile, width, height, offset;
		if (
			window.innerWidth < 800 ||
			window.screen.width < 800 ||
			this.props.data.isInsideCampaign
		) {
			mobile = true;
			width = General.toVhVw('100vw');
			height = General.toVhVw('100vh') - 50 - 37 - 3; //3 is some sort of offset
			height = this.props.headerExternalTheme ? height - 50 : height;
			offset = 0;
		} else {
			mobile = false;
			width = r.getPropertyValue('--botWidth');
			const val = r.getPropertyValue('--botHeight');
			height =
				General.toVhVw(`${val}vh`) -
				(parseInt(val) > 80
					? (parseInt(val) - 85) * 6 +
					(this.props.headerExternalTheme ? 50 : 10) //changed 30 to 50 here alone
					: 10);
			offset = 10;
		}

		try {
			if (this.props.boxRef.current)
				if (this.props.data.flyFishChangesReq) {
					if (this.props.data.isInsideKampsta) {
						this.props.boxRef.current.style.height = `${this.props.channel === 'whatsapp' ? 'calc(100vh - 114px)' : '100%'
							}`;
					}
					if (this.props.data.isInsideCampaign) {
						this.props.boxRef.current.style.height = `calc(100vh - 93px)`;
					}
					if (
						!this.props.data.isInsideCampaign &&
						!this.props.data.isInsideKampsta
					) {
						this.props.boxRef.current.style.height = '100%';
					}
				}

			if (!this.props.data.flyFishChangesReq) {
				this.props.boxRef.current.style.height = '100%';
			}
		} catch (e) {
			console.log(e);
		}
	}

	getTotalItem = (total, totalPrice) => {
		this.setState({
			totalItem: total,
			totalPrice: totalPrice,
		});
	};
	showHideWelcomeMessage(ev) {
		/* // the logic below doesn't work
		if(scrollTop >= 30){
			return;
		}else if( scrollTop < 30 && scrollTop > 10 ){
			this.setState({ isWelcomeScreenVisible: true })
		}else if (scrollTop > 10) {
			this.setState({ isWelcomeScreenVisible: false })
		}
	*/

		if (ev.target.scrollTop > SCROLL_CONST.scroll_top) {
			this.setState({ isWelcomeScreenVisible: false });
		} else {
			this.setState({ isWelcomeScreenVisible: true });
		}
	}

	handleBodyScroll(ev) {
		//debounce(this.showHideWelcomeMessage.call(this,ev),SCROLL_CONST.scroll_debounce_time);
	}

	componentDidMount() {
		//window.addEventListener("resize", resizeThrottler, false);
		this.setBotBodyHeight();
		window.addEventListener('resize', this.setBotBodyHeight.bind(this), false);
		window.addEventListener('online', this.setBotBodyHeight.bind(this), false);
		window.addEventListener('offline', this.setBotBodyHeight.bind(this), false);
		if (this.props.chatMessages.length > 1) {
			this.setState({ isWelcomeScreenVisible: false });
		}
	}

	componentWillUnmount() {
		clearTimeout(resizeTimeout);
	}

	showError = (val) => {
		this.setState({
			isError: val === null ? false : true,
			val: val,
		});
	};

	error = (val) => {
		let formatText;
		const fileSubTypeArray = val.fileSubType
			? val.fileSubType.map((e) => e.toUpperCase())
			: [];
		let last =
			(fileSubTypeArray.length > 1 ? ' or ' : '') + fileSubTypeArray.pop();
		formatText = fileSubTypeArray.join(', ') + last;
		return (
			<div
				style={{
					backgroundColor: '#848484',
					position: 'absolute',
					top: '35px',
					borderRadius: '0 0 10px 10px',
					color: 'white',
					left: '0',
					right: '0',
					margin: '15px auto',
					fontSize: '13px',
				}}
			>
				<div
					style={{
						display: 'flex',
						height: '100%',
						padding: '12px 28px 12px 12px',
						alignItems: 'center',
					}}
				>
					<div style={{ marginRight: '12px' }}>
						<img
							src={WarningIcon}
							width='24px'
							alt={TString({
								labelName: 'warningIconLabel',
								langCode: this.props.langCode,
								fromClass: true,
							})}
						/>
					</div>
					<div>
						Please ensure that your file is smaller than
						{val.fileSizeUnit === FileSizeUnitMapping.KB
							? ` ${val.fileSizeAmount} KB`
							: val.fileSizeUnit === FileSizeUnitMapping.MB
								? ` ${val.fileSizeAmount} MB`
								: 0}{' '}
						and is in {formatText} format.
					</div>
				</div>
				<span
					style={{
						fontSize: '14px',
						float: 'right',
						cursor: 'pointer',
						position: 'absolute',
						right: '8px',
						top: '4px',
					}}
					onClick={() =>
						this.setState({
							isError: false,
						})
					}
				>
					×
				</span>
				{ }
			</div>
		);
		//     val.fileSizeUnit === FileSizeUnitMapping.KB
		//       ? `${val.fileSizeAmount} KB`
		//       : val.fileSizeUnit === FileSizeUnitMapping.MB
		//       ? `${val.fileSizeAmount} MB`
		//       : 0
		//   } and  is in ${val.fileSubType.map(e => ` .${e} `)} format.`
		// );
	};

	chatBodyClick = () => {
		this.setState({
			chatBodyClick: true,
		});
	};
	changeInput = (val: any) => {
		this.setState({
			chatInput: val,
		});
	};
	submitchanges = (val: any) => {
		// this.props.HideWelcomeScreen(true);
		this.props.handleSubmit(val);
	};

	updateMonacoCartStatus = (val) => {
		this.setState({
			showMonacoCart: val,
		});
	};
	checkoutProduct = () => {
		Axios.post(
			window['BASE_URL'] + '/shop/product/checkout/create',
			{
				cartId: this.props.cartId,
				conversationId: this.props.conversationalId,
			},
			{
				headers: {
					'x-tenant-id': this.props.tenantId,
					Authorization: `Bearer ${this.props.token}`,
				},
			}
		).then((resp: any) => {
			this.setState({
				showMonacoCart: false,
			});
			let url = resp.data.response.data.data.cart.checkoutUrl;
			window.open(url, '_blank');
		});
	};

	render() {
		// console.log('this.props.currentScreen', this.props);

		return (
			<div
				onClick={this.chatBodyClick}
				id={`sf-chat-main-container`}
				className={`main-container ${this.props.data.isInsideCampaign ? '' : 'curved-edges'
					}`}
				style={
					this.props.channel === 'whatsapp'
						? {
							backgroundImage:
								this.props.currentScreen === 'homescreen' ||
									this.props.currentScreen === 'getintouchscreen'
									? ''
									: `url('https://dev.flyfish.ai/chatsdk/v1/images/whatsapp_bg6b26315d859fd5c94f2c4667ee01c3a7.png')`,
						}
						: this.props.data.backgroundType === 'color'
							? {
								backgroundColor:
									this.props.currentScreen === 'homescreen' ||
										this.props.currentScreen === 'getintouchscreen'
										? ''
										: this.props.data.backgroundColor,
							}
							: this.props.data.backgroundType === 'image'
								? {
									backgroundImage:
										this.props.currentScreen === 'homescreen' ||
											this.props.currentScreen === 'getintouchscreen'
											? ''
											: `url('${this.props.data.backgroundColor}')`,
								}
								: this.props.data.backgroundType === 'gradient'
									? {
										// backgroundImage:
										backgroundColor:
											this.props.currentScreen === 'homescreen' ||
												this.props.currentScreen === 'getintouchscreen'
												? ''
												: 'white', //this.props.data.backgroundColor,
									}
									: {
										backgroundImage:
											this.props.currentScreen === 'homescreen' ||
												this.props.currentScreen === 'getintouchscreen'
												? ''
												: 'linear-gradient(to bottom, #ffffff, #cac9fe)',
									}
				}
			>
				{this.props.mandatoryCollection ? (
					<div
						className='ff-leadgen-body'
						style={{
							overflowY: 'auto',
							flexDirection: 'column',
							display: 'flex',
							position: 'relative',
							padding: '16px 24px',
							paddingBottom: '105px',
							maxHeight: '94vh',
						}}
					>
						<GetInTouch
							handleSubmit={this.props.handleSubmit}
							WorkflowData={this.props.workflowData.workflowData}
							colorMode={this.props.data.colorMode}
							token={this.props.token}
							botId={this.props.botId}
							tenantId={this.props.tenantId}
							conversationId={this.props.conversationId}
							addUserResponse={this.props.addUserResponse}
							currentWorkflow={'generateLeads'}
							changeScreen={this.props.changeScreen}
							disableMandatory={this.props.disableMandatory}
							EbotId={this.props.EbotId}
							lang={this.props.lang}
							showToaster={() => {
								this.setState(
									{
										showToaster: true,
									},
									() => {
										this.props.handleDisableGetInTouch();
										setTimeout(() => {
											this.setState({
												showToaster: false,
											});
										}, 3000);
									}
								);
							}}
						/>
					</div>
				) : (
					<>
						<main
							className={
								this.props.currentScreen == 'chatscreen'
									? `ff-chatscreen-main ${this.props.selectedTheme}`
									: ''
							}
							ref={this.props.boxRef}
							style={{
								overflow: 'hidden',
								flexDirection: 'column',
								display: 'flex',
								position: 'relative',
								height: '435px !important',
							}}
						>
							{this.props.selectedTheme === 'monaco' ||
								this.props.selectedTheme === 'E-commerce Chat' ? (
								<>
									{this.state.showMonacoCart && this.props.cartExist ? (
										<Modal
											className='monacoCart'
											actionButtons={<></>}
											onClose={() => this.updateMonacoCartStatus(false)}
											footerNotReq={true}
										>
											<MonacoCart>
												<div className='bag-titile-and-close-button'>
													<div style={{ display: 'flex' }}>
														BAG{' '}
														<div
															style={{
																marginLeft: '4px',
																letterSpacing: '1.5px',
															}}
														>{`(${this.state.totalItem})`}</div>
													</div>
													<svg
														onClick={() => this.updateMonacoCartStatus(false)}
														className='Icon Icon--close'
														role='presentation'
														viewBox='0 0 16 14'
													>
														<path
															d='M15 0L1 14m14 0L1 0'
															stroke='currentColor'
															fill='none'
															fill-rule='evenodd'
														></path>
													</svg>
												</div>
												<div className='ff-cart-products-container'>
													<MonacoCartItem
														cartId={this.props.cartId}
														tenantId={this.props.tenantId}
														token={this.props.token}
														getTotalItem={this.getTotalItem.bind(this)}
													/>
												</div>
												<div
													className='ff-cart-checkout-button'
													onClick={() => {
														this.checkoutProduct();
													}}
												>
													<div>
														<div>Checkout</div>
														<div>.</div>
														<div>{this.state.totalPrice}</div>
													</div>
												</div>
											</MonacoCart>
										</Modal>
									) : null}
								</>
							) : null}
							{this.props.selectedTheme === 'monaco' ||
								this.props.selectedTheme === 'E-commerce Chat' ? (
								<LanguageContext.Consumer>
									{(values) => (
										<ChatInput
											voiceText={this.props.voiceText}
											enableVoiceModal={this.props.enableVoiceModal}
											cartExist={this.props.cartExist}
											showMonacoCart={this.state.showMonacoCart}
											updateMonacoCartStatus={this.updateMonacoCartStatus}
											selectedTheme={this.props.selectedTheme}
											enableGetInTouch={this.props.enableGetInTouch}
											disableGetInTouch={this.props.disableGetInTouch}
											formChatInputHidden={this.props.formChatInputHidden}
											data={this.props.data}
											getLoader={this.props.getLoader}
											snackBarMessage={this.props.snackBarMessage}
											chatInput={this.props.chatInput}
											handleInput={this.props.handleInput}
											handleFocus={this.props.handleFocus}
											handleKeyUp={this.props.handleKeyUp}
											handleSubmit={this.props.handleSubmit}
											isSpeech={truthyOrFalsy(this.props.isSpeech)}
											predSearchToggle={this.props.predSearchToggle}
											predSearchResponse={this.props.predSearchResponse}
											togglePredSearch={this.props.togglePredSearch}
											assignPredSearchQues={this.props.assignPredSearchQues}
											isChatInputDisabled={this.props.isChatInputDisabled}
											isChatInputHidden={this.props.isChatInputHidden}
											isdisableInput={this.props.isdisableInput}
											stopSpeaking={this.props.stopSpeaking}
											toggleSpeakingFunctionality={
												this.props.toggleSpeakingFunctionality
											}
											suggestions={this.props.suggestions}
											languages={this.props.data.languages}
											language_codes={values}
											setLangListVisibility={this.props.setLangListVisibility}
											isChatBodyVisible={this.props.isChatBodyVisible}
											botId={this.props.data.eB}
											persistantMenuEnabled={
												this.props.data.isShowPersistentMenuEnabled
											}
											persistantMenuData={
												this.props.data.isShowSameItemsMenuEnabled === 'true'
													? this.props.data.quicklinks
													: this.props.data.persistentMenu
											}
											isShowSameItemsMenuEnabled={
												this.props.data.isShowSameItemsMenuEnabled
											}
											quickLinks={this.props.quickLinks}
											langCode={this.props.langCode}
											voiceResponse={this.props.voiceResponse}
											channel={this.props.channel}
											toggleLang={this.props.toggleLang.bind(this)}
											showWelcomeScreen={this.props.showWelcomeScreen}
											HideWelcomeScreen={this.props.HideWelcomeScreen}
											changeScreen={this.props.changeScreen}
											currentScreen={this.props.currentScreen}
											colorScale={this.props.data.colorScale}
											colorMode={this.props.data.colorMode}
											changeInput={this.changeInput.bind(this)}
											submitchanges={this.submitchanges.bind(this)}
											showFeedbackPopup={this.props.showFeedbackPopup}
										/>
									)}
								</LanguageContext.Consumer>
							) : null}
							{this.state.showToaster && (
								<div
									style={{
										width: '100%',
										display: 'flex',
										justifyContent: 'center',
									}}
								>
									<TOASTER
										className='ff-toaster'
										colorMode={this.props.data.colorMode}
									>
										Thank you for submitting your details
									</TOASTER>
								</div>
							)}
							<Toaster>
								{this.props.toasterBodyIdentifier ===
									ToasterIdentifier.Network ? (
									<NetworkStatus
										isConnected={this.props.isConnectedToNetwork}
									/>
								) : this.props.toasterBodyIdentifier ===
									ToasterIdentifier.Other ? (
									<ToasterMessage {...this.props.toasterMessageTemplate} />
								) : null}
							</Toaster>
							{/* Mount ChatOverlay component if enabled from config */}
							{this.setBotBodyHeight()}
							{this.props.data.notification === 'true' &&
								this.props.isOverlayVisible ? (
								//dont get confused this is Notifications
								<ChatOverlay
									toggleOverlay={this.props.toggleOverlay.bind(this)}
									isOverlayVisible={this.props.isOverlayVisible}
									data={this.props.data}
									notifications={this.props.notifications}
									closeNotification={this.props.closeNotification.bind(this)}
									polls={this.props.polls}
									pollSubmit={this.props.pollSubmit.bind(this)}
									surveys={this.props.surveys}
									surveySubmit={this.props.surveySubmit.bind(this)}
									langCode={this.props.langCode}
								/>
							) : (
								<div
									className={`sf-chatbody styled-scroll ${this.props.currentScreen} ${this.props.selectedTheme} ${this.props.data.enableSplashImage === 'false' ? 'no-splash' : ''}`}
									style={{
										display: this.props.isChatBodyVisible ? '' : 'none',
										paddingTop: truthyOrFalsy(this.props.data.showCover)
											? '0'
											: truthyOrFalsy(this.props.data.showBotIcon)
												? '58px'
												: '',
										padding:
											this.props.channel === 'whatsapp' ? '18px 0px 18px' : '',
									}}
								>
									{this.props.currentScreen === 'homescreen' ? (
										<>
											<WelcomeScreen
												voiceText={this.props.voiceText}
												selectedTheme={this.props.selectedTheme}
												selectedColor={this.props.selectedColor}
												enableVoiceModal={this.props.enableVoiceModal}
												theme={this.props.theme}
												data={{
													...this.props.data,
													welcomeMessage: this.props.welcomeMessage,
												}}
												showWelcomeScreen={this.props.showWelcomeScreen}
												handleSubmit={this.props.handleSubmit}
												quickLinks={this.props.quickLinks}
												changeInput={this.changeInput.bind(this)}
												changeScreen={this.props.changeScreen}
												colorMode={this.props.data.colorMode}
												submitchanges={this.submitchanges.bind(this)}
												colorScale={this.props.data.colorScale}
											/>
										</>
									) : null}
									{this.props.chatMessages.length == 0 && window.location.search.indexOf('skipHome=true') > -1 ?
										<div style={{ height: '100%', display: 'flex', justifyContent: 'center', alignItems: 'center', textAlign: 'center' }}>
											<div className='ff-chatbot-h4'>{this.props.data.FSWelcomeHeading}</div>
											<div className='ff-chatbot-body1'>{this.props.data.FSWelcomeSubHeader}</div>
										</div>
										:
										null

									}
									{this.props.currentScreen === 'chatscreen' ? (
										<MessageFeather
											staticDetailsURL={this.props.staticDetailsURL}
											enableStyleAdvisor={this.props.enableStyleAdvisor}
											advisorTitle={this.props.advisorTitle}
											userQuery={this.props.userQuery}
											selectedButton={this.props.selectedButton}
											selectedTheme={this.props.selectedTheme}
											recommendationHeading={this.props.recommendationHeading}
											showOnHover={this.props.showOnHover}
											selectedColor={this.props.selectedColor}
											getProductDescription={this.props.getProductDescription}
											reason={this.props.reason}
											handleSelectedProduct={this.props.handleSelectedProduct}
											productCarousel={this.props.productCarousel}
											showForm={this.props.showForm}
											colorScale={this.props.data.colorScale}
											handlePaymentStatus={this.props.handlePaymentStatus}
											paymentStatus={this.props.paymentStatus}
											getProductDetails={this.props.getProductDetails}
											getCartId={this.props.getCartId}
											makePayment={this.props.makePayment}
											createCart={this.props.createCart}
											popUpSnackBar={this.props.popUpSnackBar}
											quickLinks={this.props.quickLinks}
											chatMessages={this.props.chatMessages}
											handleSubmit={this.props.handleSubmit}
											data={this.props.data}
											isCampaignWorkflowTriggered={
												this.props.isCampaignWorkflowTriggered
											}
											showError={this.showError.bind(this)}
											toggleLoginScreen={this.props.toggleLoginScreen}
											botImageCheck={
												this.props.channel === 'whatsapp'
													? false
													: truthyOrFalsy(this.props.data.showBotIcon)
											}
											coverImageCheck={truthyOrFalsy(this.props.data.showCover)}
											coverImage={this.props.data.coverImage}
											voiceResponse={this.props.voiceResponse}
											langCode={this.props.langCode}
											flyFishChangesReq={this.props.flyFishChangesReq}
											channel={this.props.channel}
											chatInput={this.props.chatInput}
											addUserResponse={this.props.addUserResponse}
											addServerMessage={this.props.addServerMessage}
											logoImagePath={this.props.logoImagePath}
											WorkflowData={this.props.workflowData.workflowData}
											colorMode={this.props.data.colorMode}
											token={this.props.token}
											botId={this.props.botId}
											tenantId={this.props.tenantId}
											conversationId={this.props.conversationId}
											openThumbsPopup={this.props.openThumbsPopup}
											thumbFilledUp={this.props.thumbFilledUp}
										/>
									) : null}

									{this.props.currentScreen === 'getintouchscreen' &&
										this.props.detailCollection ? (
										<GetInTouch
											handleSubmit={this.props.handleSubmit}
											WorkflowData={this.props.workflowData.workflowData}
											colorMode={this.props.data.colorMode}
											token={this.props.token}
											botId={this.props.botId}
											tenantId={this.props.tenantId}
											conversationId={this.props.conversationId}
											addUserResponse={this.props.addUserResponse}
											currentWorkflow={'generateLeads'}
											changeScreen={this.props.changeScreen}
											disableMandatory={this.props.disableMandatory}
											EbotId={this.props.EbotId}
											lang={this.props.lang}
											showToaster={() => {
												this.setState(
													{
														showToaster: true,
													},
													() => {
														this.props.handleDisableGetInTouch();
														setTimeout(() => {
															this.setState({
																showToaster: false,
															});
														}, 3000);
													}
												);
											}}
										/>
									) : null}
									{this.props.showFeedbackPopup ? (
										<Feedback
											submitFeedback={this.props.submitFeedback.bind(this)}
											handleModalToggle={this.props.handleModalToggle.bind(
												this
											)}
											skip={this.props.botClosingModal}
										/>
									) : null}
								</div>
							)}
							{this.props.snackBarMessage.length > 0 ? (
								<Snackbar content={this.props.snackBarMessage} />
							) : null}
							{this.props.data.isBotFrozen === 'true' ||
								this.props.isChatInputDisabled ||
								!this.props.isConnectedToNetwork ||
								this.props.isOverlayVisible ? (
								this.props.snackBarMessage.length > 0 ? (
									// <Snackbar content={this.props.snackBarMessage} />
									<></>
								) : null
							) : (
								<>
									{this.props.selectedTheme !== 'monaco' &&
										this.props.selectedTheme !== 'E-commerce Chat' ? (
										<LanguageContext.Consumer>
											{(values) => (
												<ChatInput
													voiceText={this.props.voiceText}
													enableVoiceModal={this.props.enableVoiceModal}
													cartExist={this.props.cartExist}
													selectedTheme={this.props.selectedTheme}
													enableGetInTouch={this.props.enableGetInTouch}
													disableGetInTouch={this.props.disableGetInTouch}
													formChatInputHidden={this.props.formChatInputHidden}
													data={this.props.data}
													getLoader={this.props.getLoader}
													snackBarMessage={this.props.snackBarMessage}
													chatInput={this.props.chatInput}
													handleInput={this.props.handleInput}
													handleFocus={this.props.handleFocus}
													handleKeyUp={this.props.handleKeyUp}
													handleSubmit={this.props.handleSubmit}
													isSpeech={truthyOrFalsy(this.props.isSpeech)}
													predSearchToggle={this.props.predSearchToggle}
													predSearchResponse={this.props.predSearchResponse}
													togglePredSearch={this.props.togglePredSearch}
													assignPredSearchQues={this.props.assignPredSearchQues}
													isChatInputDisabled={this.props.isChatInputDisabled}
													isChatInputHidden={this.props.isChatInputHidden}
													isdisableInput={this.props.isdisableInput}
													stopSpeaking={this.props.stopSpeaking}
													toggleSpeakingFunctionality={
														this.props.toggleSpeakingFunctionality
													}
													suggestions={this.props.suggestions}
													languages={this.props.data.languages}
													language_codes={values}
													setLangListVisibility={
														this.props.setLangListVisibility
													}
													isChatBodyVisible={this.props.isChatBodyVisible}
													botId={this.props.data.eB}
													persistantMenuEnabled={
														this.props.data.isShowPersistentMenuEnabled
													}
													persistantMenuData={
														this.props.data.isShowSameItemsMenuEnabled ===
															'true'
															? this.props.data.quicklinks
															: this.props.data.persistentMenu
													}
													isShowSameItemsMenuEnabled={
														this.props.data.isShowSameItemsMenuEnabled
													}
													quickLinks={this.props.quickLinks}
													langCode={this.props.langCode}
													voiceResponse={this.props.voiceResponse}
													channel={this.props.channel}
													toggleLang={this.props.toggleLang.bind(this)}
													showWelcomeScreen={this.props.showWelcomeScreen}
													HideWelcomeScreen={this.props.HideWelcomeScreen}
													changeScreen={this.props.changeScreen}
													currentScreen={this.props.currentScreen}
													colorScale={this.props.data.colorScale}
													colorMode={this.props.data.colorMode}
													changeInput={this.changeInput.bind(this)}
													submitchanges={this.submitchanges.bind(this)}
													showFeedbackPopup={this.props.showFeedbackPopup}
												/>
											)}
										</LanguageContext.Consumer>
									) : null}
								</>
							)}
						</main>

						{/* {
					// this.props.isChatBodyVisible
					this.props.showWelcomeScreen ||
						this.props.channel === 'whatsapp' ? (
						<></>
					) : !this.props.showFooter ? (
						<div className='footer-div'>
							<Footer
								data={this.props.data}
								handleModalToggle={this.props.handleModalToggle.bind(this)}
								langCode={this.props.langCode}
							/>
						</div>
					) : null
				} */}
						{this.state.isError ? this.error(this.state.val) : null}
					</>
				)}
			</div>
		);
	}
}

export default ChatBody;
